import { render, staticRenderFns } from "./setSupplyPrice.vue?vue&type=template&id=f82dc398&scoped=true"
import script from "./setSupplyPrice.vue?vue&type=script&lang=ts"
export * from "./setSupplyPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82dc398",
  null
  
)

export default component.exports